/*
 * @Author: Dom
 * @Date: 2022-06-01 17:15:50
 * @LastEditTime: 2022-06-28 19:34:41
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\recharge\component\uploadbank\service.ts
 */
import request from '@/utils/request'
import {UploadBankDatApi} from './data.d'

//上传银行凭证
export async function uploadBankVoucherInfo(params: UploadBankDatApi): Promise<any> {
    return request({
      url: '/seller/v1/accountRechargeFlow/uploadBankVoucherInfo',
      method: 'post',
      data: params,
    })
}
